import * as React from "react";
const SvgFinanceAndAgreement = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "finance_and_agreement_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "finance_and_agreement_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("rect", {
	width: 9,
	height: 2,
	x: 6,
	y: 7,
	rx: 1,
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("rect", {
	width: 6,
	height: 2,
	x: 6,
	y: 10,
	rx: 1,
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m21.61 4.28-6.89 10.33A1 1 0 0 0 15 16a1 1 0 0 0 1.37-.29l6.91-10.32A1 1 0 0 0 23 4a1 1 0 0 0-1.39.28M22 10.91l-2 3V20h-4.08l-1.27 2h5.21A2.14 2.14 0 0 0 22 19.86Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4 20V4h15.39l1.34-2H4.14A2.14 2.14 0 0 0 2 4.14v15.72A2.14 2.14 0 0 0 4.14 22H14l-3.14-2Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("rect", {
	width: 2.37,
	height: 2,
	x: 12.45,
	y: 17,
	rx: 1,
	transform: "rotate(-57.52 13.64 18)",
	style: { fill: "currentColor" }
}))));
export default SvgFinanceAndAgreement;
